import * as React from 'react';

import { Linking, Platform, PermissionsAndroid } from 'react-native';

import * as FileSystem from 'expo-file-system';
import Alert from './alert';

export default async function downloader(base64Data, title = 'Download') {
	const pdfFile = title + (title.endsWith('.pdf') ? '' : '.pdf');

	const downloadLink = document.createElement('a');

	downloadLink.href = 'data:application/pdf;base64,' + base64Data;
	downloadLink.download = pdfFile;
	downloadLink.click();
}
